import React from 'react';
import { render } from '@testing-library/react';
import { TagGroup } from './TagGroup';
import { Tag } from '../Tag';

describe('TagGroup', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<TagGroup data-auto-sel="automation-selector">
				<Tag key={1}>Tag</Tag>
				<Tag key={2}>Tag</Tag>
			</TagGroup>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
